import ModalRouteContainer from '@/views/modals/_shared/ModalRouteContainer.vue';

export default [
  {
    path: '/modals/:modalName',
    component: ModalRouteContainer,
    props: true,
  },
];
